import * as moment from "moment";
import * as React from "react";
import { Alert, FormGroup, HTMLSelect, NonIdealState } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { AppStore } from "../../stores/AppStore";
import { LogsStore } from "../../stores/logs/LogsStore";
import { DateRangePicker } from "../utils/DateRangePicker";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import ReactJson from "react-json-view";
import { toast } from "react-toastify";

@observer
export default class LogsXmls extends React.Component<{}, {}> {
  obs = observable({
    selectedPeriod: [] as any,
    modalViewLog: false as boolean,
    date1: "" as string,
    date2: "" as string
  })

  handleFilterClick() {
    if (this.obs.date1 == "") {
      toast.warning('Selecione um período válido', {});
      return
    }
    if (this.obs.date2 == "") {
      toast.warning('Selecione um período válido', {});
      return
    }
    if (LogsStore.obs.component == "selecione") {
      toast.warning('Selecione uma categoria.', {});
      return
    }

    LogsStore.filterLogs(this.obs.date1, this.obs.date2, LogsStore.obs.component, 1, "");
  }

  handleDateChange = (val: any) => {
    var string = val.toString();
    var array = string.split(",");

    this.obs.date1 = moment(array[0]).format("YYYY-MM-DD")
    this.obs.date2 = moment(array[1]).format("YYYY-MM-DD")

    this.obs.selectedPeriod = val;
  };

  handleBuscaLogs(page: number) {
    LogsStore.obs.current_page = page

    LogsStore.filterLogs(this.obs.date1, this.obs.date2, LogsStore.obs.component, page, "");
  }

  renderData() {
    const handleView = (row) => {
      LogsStore.obs.detalhesLog = row
      this.obs.modalViewLog = true;
    }

    function buttonFormatter(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={(e) => handleView(row.items)}
          >
            <img src="/images/view.png" width="25px" />
          </MDBBtn>
        </>
      );
    }

    let rows = LogsStore.obs.logs?.map(log => {
      return (
        {
          id: log.id,
          usuario: log.usuario,
          email: log.email,
          acao: log.acao,
          data: moment(log.inserted_at).format("DD/MM/YY") + " às " + moment(log.inserted_at).add(3, "hours").format("HH:mm"),
          items: log
        }
      );
    });

    return (
      <>
        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.modalViewLog}
          onConfirm={() => this.obs.modalViewLog = false}
          onClose={() => this.obs.modalViewLog = false}
          canOutsideClickCancel={true}
        >
          <h2 className="titleSEFAZ">Detalhes do Log</h2>

          <p>
            <b>Ação:</b> {LogsStore.obs.detalhesLog.acao}
          </p>
          <p>
            <b>Ip:</b> {LogsStore.obs.detalhesLog.ip}
          </p>
          <p>
            <b>Data:</b>{" "}
            {moment(LogsStore.obs.detalhesLog.inserted_at).add(3, "hours").format("DD/MM/YYYY")} às{" "}
            {moment(LogsStore.obs.detalhesLog.inserted_at).add(3, "hours").format("HH:mm")}
          </p>
          <p>
            <b>Dados:</b><br /><br />
            <div className="logsJson"><ReactJson displayDataTypes={true} src={LogsStore.obs.detalhesLog.dados} /></div>
          </p>
        </Alert>

        <MDBRow>
          <MDBCol xl="3" lg="3" md="3" sm="3" xs="12">
            <FormGroup label="Categoria" className="nz-horizontal-field">
              <HTMLSelect onChange={(e) => LogsStore.obs.component = e.target.value} value={LogsStore.obs.component}>
                <option value="selecione">Selecione</option>
                <option value="importacao">Importação de XMLs</option>
                <option value="manifestacoes">Manifestações</option>
                <option value="prefeitura">NFS Prefeitura Marabá</option>
                <option value="sefa">Solicitações SEFA</option>
                <option value="xml_download">Download de Xml</option>
              </HTMLSelect>
            </FormGroup>
          </MDBCol>
          <MDBCol xl="3" lg="3" md="3" sm="3" xs="12">
            <FormGroup label="Período" className="inputsPeriodoCalculos">
              <DateRangePicker
                onChange={this.handleDateChange}
                value={this.obs.selectedPeriod}
              />
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <MDBBtn
              className="btnDefault btnBuscarNfe mt25"
              onClick={() => this.handleFilterClick()}
            >
              Buscar
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <BootstrapTable className="TableDefault" data={rows}>
          <TableHeaderColumn dataField="id" isKey={true} hidden>
            #
          </TableHeaderColumn>
          <TableHeaderColumn dataField="usuario" width="30%">
            Usuário
          </TableHeaderColumn>
          <TableHeaderColumn dataField="email" width="30%">
            E-mail
          </TableHeaderColumn>
          <TableHeaderColumn dataField="acao" width="40%">
            Ação
          </TableHeaderColumn>
          <TableHeaderColumn dataField="data" width="15%">
            Data
          </TableHeaderColumn>
          <TableHeaderColumn dataFormat={buttonFormatter} width="10%">
            Detalhes
          </TableHeaderColumn>
        </BootstrapTable>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={LogsStore.obs.current_page}
            totalCount={LogsStore.obs.logs_length}
            pageSize={50}
            onPageChange={page => this.handleBuscaLogs(page)}
          />
        </div>
      </>
    );
  }

  renderNonIdeal() {
    return (
      <div className="nz-non-ideal">
        <NonIdealState
          icon="box"
          title="Você não possui permissão para acessar essa página"
        />
      </div>
    );
  }

  renderNormal() {
    return (
      <>
        {this.renderData()}
      </>
    );
  }

  render() {
    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];
    if (niveis_acesso.indexOf("l1") == -1) {
      return this.renderNonIdeal();
    } else {
      return this.renderNormal();
    }
  }
}
